var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.computedTitle))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            [
              _c(
                "w-list-item",
                [
                  _c(
                    "w-list-item-icon",
                    [
                      _c("w-checkbox", {
                        attrs: { value: _vm.allItemsSelected },
                        on: {
                          click: function ($event) {
                            return _vm.toggleAllItemsSelected()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(_vm.$ct("common.select-all")) + " "),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.bookyears, function (year) {
                return _c(
                  "w-list-item",
                  { key: year.Year },
                  [
                    _c(
                      "w-list-item-icon",
                      [
                        _c("w-checkbox", {
                          attrs: { value: _vm.isBookYearSelected(year.Year) },
                          on: {
                            click: function ($event) {
                              return _vm.toggleBookYear(year.Year)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c("w-list-item-text", [_vm._v(_vm._s(year.Year))]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check", disabled: _vm.confirmDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }